<template>
    <v-fade-transition>
        <v-card v-if="loading || activities !== null" flat class="section-card student-activity-feed mb-6 mb-lg-10">
            <v-card-title v-if="pcOnly" class="d-flex justify-space-between pt-0 pt-lg-4" :style="pcOnly ? 'font-size: 1.4rem' : ''">
                <div>آخر نشاطاتك</div>
            </v-card-title>
            <v-card-subtitle v-if="pcOnly" class="pb-2">
                مشترياتك، امتحاناتك، واجباتك، وأسئلتك
            </v-card-subtitle>
            <v-subheader v-if="phoneOnly" class="mt-2">آخر نشاطاتك</v-subheader>

            <v-card-text class="pt-0 py-lg-4 px-0 px-lg-4">
                <v-progress-linear
                    v-if="loading"
                    indeterminate
                    color="secondary"
                    height="2"
                    class="mb-3"
                />

                <v-list v-if="activities && activities.length" class="py-0">
                    <template v-for="activity in activities">
                        <v-list-item
                            :key="activity.id"
                            :to="activity.route"
                            class="py-2"
                            :class="{'bordered rounded mb-3 px-4 mx-2 mx-lg-0': pcOnly, 'px-4': phoneOnly}"
                            v-ripple
                        >
                            <v-list-item-icon class="my-auto grey lighten-3 pa-3 rounded" :class="{'me-4': phoneOnly}">
                                <v-icon size="24" color="strong-text">{{ activity.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title class="strong-text--text medium-text">
                                    {{ activity.title }}
                                    <span v-if="activity.label" class="ms-1">{{ activity.label }}</span>
                                </v-list-item-title>
                                <v-list-item-subtitle class="mt-1">
                                    <v-chip
                                        v-if="activity.at"
                                        label
                                        small
                                        outlined
                                        class="ltr-dir px-2 me-2"
                                        style="height: 22px;"
                                    >
                                        {{ formatActivityTime(activity.at) }}
                                    </v-chip>
                                    <v-chip
                                        v-for="(chip, chipIndex) in activity.chips"
                                        :key="`${activity.id}-chip-${chipIndex}`"
                                        label
                                        small
                                        :color="chip.color"
                                        :outlined="chip.outlined"
                                        :dark="chip.dark"
                                        class="px-2 me-2"
                                        style="height: 22px;"
                                        :class="{'ltr-dir': chip.ltr}"
                                    >
                                        {{ chip.text }}
                                    </v-chip>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-icon class="my-auto ms-2">
                                <v-icon size="20" color="grey">mdi-chevron-left</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                        <v-divider v-if="phoneOnly" inset :key="`divider-${activity.id}`" style="opacity: 0.6" />
                    </template>
                </v-list>

                <div v-else-if="!loading" class="pa-4 pa-lg-0">
                    <v-alert type="info" color="blue-grey" text class="mb-0">
                        <div class="details-text">لا يوجد نشاط حديث بعد</div>
                    </v-alert>
                </div>
            </v-card-text>
        </v-card>
    </v-fade-transition>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed';
import GlobalMethods from '@/helpers/global-methods';

export default {
    name: 'StudentActivityFeed',
    props: {
        activities: {
            type: Array,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...GlobalComputed,
    },
    methods: {
        ...GlobalMethods,
        formatActivityTime(at) {
            if (typeof at === 'number') {
                return this.dateTimeFormat(at, true);
            }
            if (typeof at === 'string') {
                if (/^\d+$/.test(at)) {
                    return this.dateTimeFormat(Number(at), true);
                }
                return this.dateTimeFormat(at, false);
            }
            return '';
        },
    },
};
</script>

<style lang="scss" scoped>
.student-activity-feed {
    .v-list-item__subtitle {
        white-space: normal;
    }
}
</style>
